.b8{flex-shrink:0;}